/**
 * i18n/index.ts — DysTest i18n entry point
 *
 * Usage:
 *   import { useT } from '@/hooks/useT';
 *
 * To add a new language:
 *   1. Create src/i18n/<code>.ts satisfying the Translations interface in types.ts
 *   2. Add the code to LangCode in types.ts
 *   3. Import it below and add it to the translations record
 */

import type { LangCode, Translations } from "./types";
import en from "./en";
import nl from "./nl";
import fr from "./fr";
import de from "./de";
import hi from "./hi";
import es from "./es";
import pt from "./pt";
import it from "./it";

export type { LangCode, Translations };

export const translations: Record<LangCode, Translations> = {
  en,
  nl,
  fr,
  de,
  hi,
  es,
  pt,
  it,
};

/** Fallback to English for unknown/unsupported language codes. */
export function getTranslations(langCode: string): Translations {
  return translations[langCode as LangCode] ?? translations.en;
}
